module.exports = __webpack_public_path__ + "static/media/思享荟2.3b207fd2.png";